import { render, staticRenderFns } from "./task-fakeback.vue?vue&type=template&id=1c79c9b2&scoped=true&lang=pug&"
import script from "./task-fakeback.vue?vue&type=script&lang=js&"
export * from "./task-fakeback.vue?vue&type=script&lang=js&"
import style0 from "./task-fakeback.vue?vue&type=style&index=0&id=1c79c9b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c79c9b2",
  null
  
)

export default component.exports